var Vue = require('vue');
var OrderBillingDetails = require('./OrderBillingDetails.vue').default;
var OrderNotes = require('./OrderNotes.vue').default;

module.exports = function() {
    new Vue({
        el: '#order-billing-details',
        components: {
            'order-billing-details': OrderBillingDetails
        }
    });

    new Vue({
        el: '#order-notes',
        components: {
            'order-notes': OrderNotes
        }
    });
};
